// Document d'un inventaire staff, au format attendu par /dashboard/inventories/insert-staff.

import { objectCount } from './fieldReference'
import { summarize } from './fieldSummary'
import { duringCommentItems, duringPhotoItems } from './fieldNotes'

function commentEntry({ comment, themeName })
{
	return {
		id: comment.id,
		comment: (comment.comment || '').trim(),
		user: comment.commentUser,
		timestamp: comment.commentTime,
		theme: themeName,
		after: false
	}
}

// Les photos partent d'abord sur /dashboard/files/add-image (saveStaffInventory) : file_id est rempli à l'envoi
function pictureEntry({ photo, themeName })
{
	return {
		id: photo.id,
		file: photo.file,
		file_id: photo.file_id || null,
		description: (photo.description || '').trim(),
		user: photo.user,
		timestamp: photo.time,
		theme: themeName,
		after: false
	}
}

// Sans référence (aucun modèle), un objet non compté vaut sa quantité prévue, comme dans buildReference
function countOf(object, counts, reference)
{
	if (reference)
		return objectCount(object, counts, reference, true)
	return counts[object.id] !== undefined ? counts[object.id] : object.expected
}

export function buildStaffInventory({ type, pitch, stay, accommodationId, themes, counts, reference, notes, user, now })
{
	const allThemes = themes || []
	const comments = duringCommentItems(allThemes, notes).map(commentEntry)
	const pictures = duringPhotoItems(allThemes, notes).map(pictureEntry)

	const withModel = allThemes.length > 0 && !!reference
	const summary = withModel ? summarize(type, allThemes, counts, reference, now) : null
	const userId = user ? user._id : null
	return {
		type,
		source: 'staff',
		stay_number: stay ? stay.stay_number : null,
		location_id: pitch._id || null,
		location: pitch.location,
		accommodation_id: withModel ? (accommodationId || null) : null,
		tour_id: null,
		create_user: userId,
		create_time: now,
		version: 1,
		inventory: allThemes.map(theme => ({
			name: theme.name,
			objects: theme.objects.map(object => ({ name: object.name, quantity: object.expected, count: countOf(object, counts, reference) }))
		})),
		comment: comments,
		pictures,
		contributors: userId ? [userId] : [],
		reference_entry: withModel && reference.source === 'inventory' && reference.id ? { inventory_id: reference.id, version: reference.version || 1 } : null,
		verdict: summary ? summary.verdict : null
	}
}
